class RecipeTileController {
    constructor(analyticsService, recipeService) {
        this.analyticsService = analyticsService;
        this.recipeService = recipeService;
    }

    $onInit() {
        this.isJamieRecipe = this.recipe.TemplateName.toLowerCase() !== 'default';
    }

    pushDataToAnalyticsService() {
        this.recipeService.getRecipe(this.recipe.ID).then((data) => {
            this.analyticsService.push({
                data: {
                    trackingType: 'link',
                    recipe: data,
                },
                type: this.analyticsService.mapperTypes.customEvent.recipeClick,
            });
        });
    }
}

RecipeTileController.$inject = ['AnalyticsService', 'RecipeService'];

const recipeTileComponentDefinition = {
    bindings: {
        recipe: '<',
    },
    controller: RecipeTileController,
    template: require('./recipe-tile.component.html').trim(),
};

module.exports = {
    RecipeTileController,
    recipeTileComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/recipe/recipetile/recipe-tile.component.js